/* eslint-disable import/prefer-default-export */
export const GET_REFERRAL_REQUEST = 'GET_REFERRAL_REQUEST';
